var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-card",
    {
      staticClass: "card-estimate_corp",
      attrs: {
        isCustomizable: _vm.settings.isCustomizable,
        loading: _vm.loading,
        type: _vm.settings.context,
        error: _vm.error
      },
      on: {
        "edit-card": _vm.toggleSettingsForm,
        "hide-card": function($event) {
          return _vm.$emit("hide-card", _vm.type)
        },
        "refresh-card": function($event) {
          return _vm.fetchCard(_vm.type, {}, true)
        }
      }
    },
    [
      _c("template", { slot: "title" }, [
        _vm._v("\n        " + _vm._s(_vm.name) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "content" },
        [
          _c("template-kpi-card", {
            attrs: { data: { stats: _vm.cardData, labels: _vm.labels } }
          }),
          _vm._v(" "),
          _c(
            "portal",
            { attrs: { to: "dashboardSettingsForm" } },
            [
              _vm.showSettingsForm
                ? _c("card-setting-overlay", {
                    attrs: {
                      formName: _vm.settingsFormName,
                      cardCustomSettings: _vm.customSettings,
                      cardName: _vm.type
                    },
                    on: {
                      fetched: _vm.fetchCard,
                      "close-form": _vm.toggleSettingsForm,
                      "custom-settings-saved": function($event) {
                        return _vm.fetchCard(_vm.type, {}, true)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("fiscal-year-footer", {
            attrs: { fiscalYearTimestamp: _vm.fiscalYear }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }